import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    RightComponents,
} from '../../components/Layout';
import {
    Button,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import SystemTaroffTaroffCollectRequestsEdit from '../collect/SystemTaroffTaroffCollectRequestsEdit';
import { postData } from '../../Api';

export default function TaroffPeikCollectRequests(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-peik-collect-requests/table-data', {
            size: tableSize,
            page: tablePage,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp1 = (row) => {
        setModal(
            Modal({
                children: (
                    <SystemTaroffTaroffCollectRequestsEdit
                        taroff-collect-requests-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Title>درخواست های جمع آوری</Title>
            <RightComponents wrap={true}>
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>فروشگاه</TableColumn>
                        <TableColumn mobile={false}>تاریخ</TableColumn>
                        <TableColumn mobile={false}>زمان</TableColumn>
                        <TableColumn mobile={false}>تعداد</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_shop_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>{row.text_date}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_time_id_color}>
                                    {row.text_time_id_title}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_count}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_state_id_color}>
                                    {row.text_state_id_title}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_peik_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-datetime-normal'}>
                                    {row.text_insert_time}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <Button
                                    onClick={() => handlecomp1(row)}
                                    rightIcon={'far fa-edit'}
                                    tooltip={'ویرایش'}
                                ></Button>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
